import React, { Dispatch, ReactNode, createContext, useContext, useReducer } from "react";

import { ILoginParam } from "../../api/user/user";

import useLocalStorage from "../../hooks/useLocalStorage";

type Action = { type: "login"; payload: ILoginParam } | { type: "logout" };

const initialState = { value: { accessToken: "", refreshToken: "" } };

const reducer = (session: any, action: Action) => {
    switch (action.type) {
        case "login":
            return session;
        case "logout":
            return initialState;
        default:
            return session;
    }
};

interface ContextProps {
    session: any;
    signAction: Dispatch<Action>;
    userSession: any;
    setUserSession: any;
}

const SessionContext = createContext<ContextProps>({
    session: initialState,
    signAction: () => {},
    userSession: initialState,
    setUserSession: () => {},
});

function SessionProvider({ children }: { children: ReactNode }) {
    const [session, signAction] = useReducer(reducer, initialState);
    const [userSession, setUserSession] = useLocalStorage<any>("userSession", {}, 86400000 * 30);

    return (
        <SessionContext.Provider
            value={{
                session,
                signAction,
                userSession,
                setUserSession,
            }}
        >
            {children}
        </SessionContext.Provider>
    );
}

const useSession = () => useContext(SessionContext);

export { useSession, SessionProvider };
